module.exports = __webpack_public_path__ + "car-showroom.jpg?29f05dbec67cb81ab738939fd3299882";